import React, { useState } from 'react';
import DiscoveryWizard from '../components/DiscoveryWizard';
import DiscoveryResults from '../components/DiscoveryResults';
import { 
  ArrowLeftIcon,
  CheckCircleIcon,
  ClockIcon 
} from '@heroicons/react/24/outline';

export default function LegalDiscovery() {
  const [currentView, setCurrentView] = useState('wizard'); // 'wizard', 'results'
  const [activeJob, setActiveJob] = useState(null);

  const handleWizardComplete = (result) => {
    setActiveJob(result);
    setCurrentView('results');
  };

  const handleBackToWizard = () => {
    setCurrentView('wizard');
    setActiveJob(null);
  };

  if (currentView === 'results' && activeJob) {
    return (
      <div className="max-w-6xl mx-auto">
        {/* Header with back button */}
        <div className="mb-6 flex items-center">
          <button
            onClick={handleBackToWizard}
            className="flex items-center px-4 py-2 text-sm text-gray-600 hover:text-gray-900 transition-colors mr-4"
          >
            <ArrowLeftIcon className="w-4 h-4 mr-2" />
            New Discovery Analysis
          </button>
          
          <div className="flex-1">
            <h1 className="text-2xl font-bold text-gray-900">{activeJob.caseName}</h1>
            <div className="flex items-center mt-1">
              <span className="text-sm text-gray-500 mr-4">Case ID: {activeJob.caseId}</span>
              <div className="flex items-center text-sm text-blue-600">
                <ClockIcon className="w-4 h-4 mr-1" />
                Processing Job: {activeJob.jobId}
              </div>
            </div>
          </div>
        </div>

        <DiscoveryResults 
          caseId={activeJob.caseId}
          jobId={activeJob.jobId}
        />
      </div>
    );
  }

  return (
    <DiscoveryWizard onComplete={handleWizardComplete} />
  );
}